import { Component, Input, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { LngLatBounds, LngLat, Map, NavigationControl } from 'mapbox-gl';
import * as mapboxgl from 'mapbox-gl';
import { environment } from 'src/environments/environment';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { AppLoadingService } from '../../services/apploading.service';
import { HttpService } from 'src/app/core/http/http.service';
import { API } from 'src/app/configs';
import { GeneralService } from '../../services/general.service';

@Component({
    selector: 'heatmap',
    templateUrl: './heatmap.component.html',
    styleUrls: ['./heatmap.component.scss']
})
export class HeatmapComponent implements AfterViewInit {

    dialogRef: MatDialogRef<any>;

    map: Map;
    style = 'mapbox://styles/mapbox/light-v10';

    @Input() zoom: number = 10;

    id: any;
    params:any={};
    empty: any = false;

    loading: any = true;


    _address: any = {};
    _latitude: number = 0;
    _longitude: number = 0;

    constructor(
        protected als: AppLoadingService,
        public dialog: MatDialog,
        protected cdr : ChangeDetectorRef,
        protected httpService: HttpService,
        protected gs: GeneralService
    ) {
        
    }

    ngAfterViewInit() {
        Object.getOwnPropertyDescriptor(mapboxgl, "accessToken").set(environment.mapbox.accessToken);
        if(!this.params?.type)
            return;

        this.load();
    }

    load() {

        this.als.setLoaded(false, 'heatmap');

        this.httpService.post<any>(API[this.params?.type].general.heatmap.setArgs(['views']), {
            ...(this.params?.ad_id? {"id": this.params.ad_id} : {}),
            "owner_person_id": this.gs.getCompanieSel()
        })
            .then(result => {
                this.loadMap(result);
            })
            .catch((err) => { this.gs.error(err); })
            .finally(() => {
                this.als.setLoaded(true, 'heatmap');
            });
    }

    loadMap(points:any){

        this.empty = !points?.length;
        if(this.empty)
            return true;

        if (this.map)
            this.map.remove();
 
        let data : any = [];
        var bounds:mapboxgl.LngLatBounds = new LngLatBounds();

        points?.map(item => {
            if(item.data){
                let coords = typeof item.data =='string'? JSON.parse(item.data) : [item];
                coords?.map(coord => {
                    data.push({ "type": "Feature", "properties": coord, "geometry": { "type": "Point", "coordinates": [coord[2], coord[1], 0.0] } });
                    bounds.extend(new LngLat(coord[2], coord[1]));                
                });
            } else if(typeof item  === 'object') {
                data.push({ "type": "Feature", "properties": item, "geometry": { "type": "Point", "coordinates": [item[2], item[1], 0.0] } });
                bounds.extend(new LngLat(item[2], item[1]));                
            }
        });

        if(!data?.length){
            this.empty = true;
            return false;
        }

        let th = this;

        this.map = new Map({
            container: 'map',
            style: this.style,
            zoom: this.zoom,
            maxZoom: 13,
            fitBoundsOptions : { padding: 100, maxZoom: 13 },
            center : bounds.getCenter()
        })
        .on('load', function() {
            th.updateMap(bounds, data);
            th.loading = false;
            th.cdr.detectChanges();
        });
    }

    updateMap(bounds:any, data:any) {

        this.map.fitBounds(bounds, {
            padding: 200
        });

        this.map.addSource('earthquakes', {
            'type': 'geojson',
            'data': {
                "type": "FeatureCollection",
                "features": data
            }
            });

        this.map.addLayer(
            {
                'id': 'earthquakes-heat',
                'type': 'heatmap',
                'source': 'earthquakes',
                'maxzoom': 15,
                'paint': {
                    // Increase the heatmap weight based on frequency and property magnitude
                    'heatmap-weight': [
                        'interpolate',
                        ['linear'],
                        ['get', 'mag'],
                        0,
                        0,
                        6,
                        1
                    ],
                    // Increase the heatmap color weight weight by zoom level
                    // heatmap-intensity is a multiplier on top of heatmap-weight
                    'heatmap-intensity': [
                        'interpolate',
                        ['linear'],
                        ['zoom'],
                        0,
                        1,
                        15,
                        3
                    ],
                    // Color ramp for heatmap.  Domain is 0 (low) to 1 (high).
                    // Begin color ramp at 0-stop with a 0-transparancy color
                    // to create a blur-like effect.
                    'heatmap-color': [
                        'interpolate',
                        ['linear'],
                        ['heatmap-density'],
                        0,
                        'rgba(33,102,172,0)',
                        0.4,
                        'rgb(103,169,207)',
                        
                        0.7,
                        'rgb(97, 185, 239)',
                        1,
                        'rgb(24, 30, 180)'
                    ],
                    // Adjust the heatmap radius by zoom level
                    'heatmap-radius': [
                        'interpolate',
                        ['linear'],
                        ['zoom'],
                        0,
                        2,
                        15,
                        20
                    ],
                    // Transition from heatmap to circle layer by zoom level
                    'heatmap-opacity': [
                        'interpolate',
                        ['linear'],
                        ['zoom'],
                        7,
                        1,
                        15,
                        0.8
                    ]
                }
            },
            'waterway-label'
        );

        
    }

}
